import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'visaoGeral', ptBr);
i18next.addResourceBundle('en', 'visaoGeral', en);

const VisaoGeralConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/visao-geral',
      component: React.lazy(() => import('./VisaoGeral')),
    },
  ],
};

export default VisaoGeralConfig;
